export enum SessionStorageKeyEnum {
  BOOKING_TOKEN = 'BOOKING_TOKEN',
  RESCHEDULE_TOKEN = 'RESCHEDULE_BOOKING_TOKEN',
}
